import { render, staticRenderFns } from "./PhotoClipPreview.vue?vue&type=template&id=3467fdb2"
import script from "./PhotoClipPreview.vue?vue&type=script&lang=js"
export * from "./PhotoClipPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports